module.exports = __webpack_public_path__ + "static/media/cancel.222a722d.svg";